module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-terminal m-r-xs"
  }), _vm._v(" Ações "), _c('span', {
    staticClass: "m-l-sm caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right no-padder"
  }, [_c('li', [_c('a', {
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": _vm.renovarCache
    }
  }, [_c('i', {
    staticClass: "fa fa-hdd-o m-r-xs"
  }), _vm._v(" Renovar Cache\n      ")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'leilao.monitor-comitente',
        params: {
          leilao: _vm.leilao.id
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o fa-fw"
  }), _vm._v(" Enviar Cobrança de Vendidos\n      ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": _vm.emailsAutomaticos
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o fa-fw"
  }), _vm._v(" Executar Envio Automático de E-mails\n      ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": _vm.updateTransmissaoUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-video-camera fa-fw"
  }), _vm._v(" Atualizar Vídeo de Transmissão\n      ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": _vm.gerarArquivoRemessa
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Gerar arquivo de remessa\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a30e4f1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/BtnLeilaoAcoes.vue
// module id = 1783
// module chunks = 17